import React from "react";
import { Link } from "react-router-dom";
import { homePageV2Hero } from "../content/homePageV2Content";

export function HeroSectionV2() {
  const { title, cta, image } = homePageV2Hero;

  return (
    <section
      className="mh2v2-hero"
      style={{
        backgroundColor: "#d9e6e3",
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center 35%",
        backgroundRepeat: "no-repeat",
      }}
      aria-labelledby="mh2v2-hero-title"
    >
      <div className="mh2v2-hero__overlay mh2v2-container">
        <h1 id="mh2v2-hero-title" className="mh2v2-hero__title">
          {title}
        </h1>
        <Link to={cta.to} className="mh2v2-pill">
          {cta.label} →
        </Link>
      </div>
    </section>
  );
}

export default HeroSectionV2;
